import { components } from "@certn/legacy-api/generated-schemas/people";

// Order applications:
// 1. Applications with expiry dates in the future (asc)
// 2. Applications with null expiry dates
// 3. Applications with expiry dates in the past (asc)
export function compareDates(
  a: components["schemas"]["ApplicationsList"],
  b: components["schemas"]["ApplicationsList"]
) {
  const expiryDateA = a.expiry_date && new Date(a.expiry_date);
  const isExpiredA = expiryDateA && expiryDateA < new Date();
  const expiryDateB = b.expiry_date && new Date(b.expiry_date);
  const isExpiredB = expiryDateB && expiryDateB < new Date();

  if (isExpiredA && isExpiredB) {
    return expiryDateA < expiryDateB ? -1 : 0;
  }

  if (isExpiredB) {
    return -1;
  }

  if (isExpiredA) {
    return 0;
  }

  if (!expiryDateA) {
    return 0;
  }

  if (!expiryDateB) {
    return -1;
  }

  return expiryDateA < expiryDateB ? -1 : 0;
}
